/**
 * File size validation
 */
$(function() {
    function disableForm($form) {
        $form.find('button[type=submit]').attr('disabled', 'disabled');
    }

    function enableForm($form) {
        $form.find('button[type=submit]').removeAttr('disabled');
    }

    function updateFormState($form) {
        if ($form.has('[data-file-error]').length > 0) {
            disableForm($form);
        } else {
            enableForm($form);
        }
    }

    function createError(text) {
        return '<span data-file-error class="help-block"><ul class="list-unstyled"><li><span class="glyphicon glyphicon-exclamation-sign"></span> ' + text + ' </li></ul></span>';
    }

    function setError($el, text) {
        if (text == null) {
            $el.siblings('.help-block').remove();
            $el.closest('.form-group').removeClass('has-error');

            return;
        }

        $el.siblings('.help-block').remove();
        $el.after(createError(text));
        $el.closest('.form-group').addClass('has-error');
    }

    function createFormError(text) {
        return '<div data-file-error class="alert alert-danger"><ul class="list-unstyled"><li><span class="glyphicon glyphicon-exclamation-sign"></span>' + text + '</li></ul></div>';
    }

    function setFormError($form, text) {
        const $content = $form.find('.panel-body');
        if (text == null) {
            $content.find('.alert').remove();
            
            return;
        }

        $content.find('.alert').remove();
        $content.prepend(createFormError(text));
    }

    function add(x, y) {
        return x + y;
    }

    function fileSize(el) {
        return Array.from(el.files || [])
            .map(f => f.size)
            .reduce(add, 0);
    }

    /**
     * https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
     */
    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 B';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    /**
     * Currently takes into account only files
     */
    function postSize($form) {
        return $form.find('input[type=file]').get()
            .map(fileSize)
            .reduce(add, 0);
    }

    $('input[type=file]').on('change', function(e) {
        const $input = $(this);

        const maxSize = $input.data('appMaxSize');
        const currentFileSize = fileSize(e.currentTarget);
        if (currentFileSize > maxSize) {
            const violation = $input.data('appMaxSizeMessage').replace('%max_size%', formatBytes(maxSize));
            setError($input, violation);
        } else {
            setError($input, null);
        }

        const maxPostSize = $input.data('appMaxPostSize');
        const $form = $input.closest('form');
        const currentPostSize = postSize($form);
        if (currentPostSize > maxPostSize) {
            const violation = $input.data('appMaxPostSizeMessage').replace('%max_size%', formatBytes(maxPostSize));
            setFormError($form, violation);
        } else {
            setFormError($form, null);
        }

        updateFormState($form);
    });
});
